'use client';

import { forwardRef } from 'react';

import { cx } from '@/styled-system/css';

import { Icon } from '../icon/icon';
import { inputChipIconStyles } from './styles/input-chip-icon.styles';
import type { InputChipIconPropsInterface } from './types/input-chip-icon.types';

/**
 * @since 10.0.0
 */
export const InputChipIcon = forwardRef<SVGSVGElement, InputChipIconPropsInterface>(
  (props, forwardedRef) => {
    const { children, css: cssProp, ...rest } = props;

    return (
      <Icon
        data-c11n-component="InputChip.Icon"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        css={{ ...inputChipIconStyles, ...cssProp }}
        {...rest}
        className={cx('c11n_input-chip__icon', rest.className)}
      >
        {children}
      </Icon>
    );
  },
);

InputChipIcon.displayName = 'InputChip.Icon';
